import { QueryClient } from '@tanstack/react-query'

/**
 * The app-wide React Query client singleton. Extracted to its own module so
 * non-React code (route onEnter guards, logout handlers) can import it without
 * pulling in the whole AppContainer/router tree (which would risk import
 * cycles). AppContainer imports this and provides it via QueryClientProvider.
 */
export const queryClient = new QueryClient()
